// Loud scanner beep + haptic tick. iOS/Safari safe with lazy unlock.
let ctx = null;

function ensure() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

function play() {
  const c = ensure();
  if (!c || c.state === "closed") return;
  const now = c.currentTime;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "square";
  osc.frequency.value = 2100;
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.9, now + 0.005);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.18);
  osc.connect(gain).connect(c.destination);
  osc.start(now);
  osc.stop(now + 0.2);
}

export function beep() {
  try {
    const c = ensure();
    if (!c) return;
    if (c.state === "suspended") c.resume().then(play).catch(() => {});
    else play();
  } catch {}
  try { navigator.vibrate?.(60); } catch {}
}

// Call once from a real user gesture (button tap) to unlock iOS audio.
export function unlockAudio() {
  try {
    const c = ensure();
    if (!c) return;
    if (c.state === "suspended") c.resume();
    const src = c.createBufferSource();
    src.buffer = c.createBuffer(1, 1, 22050);
    src.connect(c.destination);
    src.start(0);
  } catch {}
}
